module.exports = __webpack_public_path__ + "img/bannerProduct.6ac812be.png";